import type { MouseEvent } from 'react';
import { cssToStyle } from '@aithora/shared';

/**
 * The design's style-hover="..." attribute: the extra declarations apply while the pointer
 * is over the element and are taken off when it leaves.
 */
export function hov(css: string) {
  const extra = cssToStyle(css) as Record<string, string>;
  return {
    onMouseEnter: (e: MouseEvent<HTMLElement>) => {
      const el = e.currentTarget;
      const prev: Record<string, string> = {};
      for (const k of Object.keys(extra)) {
        prev[k] = (el.style as unknown as Record<string, string>)[k];
        (el.style as unknown as Record<string, string>)[k] = extra[k];
      }
      (el as HTMLElement & { __hovPrev?: Record<string, string> }).__hovPrev = prev;
    },
    onMouseLeave: (e: MouseEvent<HTMLElement>) => {
      const el = e.currentTarget as HTMLElement & { __hovPrev?: Record<string, string> };
      const prev = el.__hovPrev;
      if (!prev) return;
      for (const k of Object.keys(prev)) (el.style as unknown as Record<string, string>)[k] = prev[k];
      el.__hovPrev = undefined;
    },
  };
}

/** The design's `pre(e)`: a link that acts, never navigates. */
export function pre(e?: { preventDefault?: () => void } | null) {
  if (e && e.preventDefault) e.preventDefault();
}
